import {
  API,
  checkWindow,
  ErrorDetail,
  errorManager,
  ErrorService,
  getFromSessionStorageByKey,
} from '@vfit/shared/data-access';
import { Loading } from '../Loading';
import { useEffect } from 'react';
import {
  CONSUMER_CMS_DEFAULT,
  ICGradeLoadingCMS,
  useCmsConfig,
  useSilentLogin,
} from '@vfit/consumer/data-access';
import { datadogRum } from '@datadog/browser-rum';

const VerificaIdentitaAmdocs = () => {
  const baseUrl = (checkWindow() && window.location.origin) || '';
  const querystringParams = (checkWindow() && window.location.search) || '';
  const urlParams = new URLSearchParams(querystringParams);
  const shareCode =
    urlParams?.get('share_code') || urlParams?.get('shareCode') || urlParams?.get('shared');
  const isReturnFromLogin = urlParams.toString() === '';
  const ANONYMOUS_KEYS = ['newAnonymous', 'existingAnonymous'];
  const LOGGED_KEYS = ['existingLogin', 'newLogin'];
  const isDev = process.env['NODE_ENV'] === 'development';
  const isMockCDA = process?.env?.['NEXT_PUBLIC_MOCK_CDA'] === 'TRUE';

  const { cgradeloading } =
    (useCmsConfig(CONSUMER_CMS_DEFAULT, API.CMS_GET_CGRADE_LOADING) as ICGradeLoadingCMS) || {};

  const {
    mutate: silentLoginMutate,
    isSuccess: isSuccessSilentLogin,
    isError: isErrorSilentLogin,
    data: dataSilentLogin,
  } = useSilentLogin();

  const onSuccessSilentLogin = () => {
    if (!dataSilentLogin || ANONYMOUS_KEYS?.includes(dataSilentLogin?.flowId)) {
      sessionStorage.removeItem('CDAParams');
      const errorGeneric: ErrorDetail = {
        message: 'Si è verificato un errore.',
        title: 'Ops',
        actionEvent: () => {
          if (checkWindow()) {
            window.location.href = '/';
          }
        },
        actionText: 'Chiudi',
      };
      errorManager.handleError(ErrorService.getSeverityErrorHigh(), errorGeneric);
    } else if (LOGGED_KEYS?.includes(dataSilentLogin?.flowId)) {
      const shoppingCartParams = getFromSessionStorageByKey('CDAParams');
      const urlToRedirect = new URL(`${baseUrl}/shopping-cart`);
      for (const [key, value] of Object.entries(shoppingCartParams)) {
        urlToRedirect?.searchParams?.append(key, value as string);
      }
      datadogRum.addAction('CDA IADD CART PARAMS', {
        type: 'CONSUMER',
        url: window.location.href,
        params: shoppingCartParams,
      });
      if (checkWindow()) {
        sessionStorage.removeItem('CDAParams');
        window.location.replace(urlToRedirect.toString());
      }
    }
  };

  const initCDA = () => {
    if (isReturnFromLogin) silentLoginMutate(true);
    else {
      const shoppingCartParams = {
        app: urlParams.get('app'),
        flowType: urlParams.get('flowType'),
        icmp: urlParams.get('icmp'),
        placeId: urlParams.get('placeId'),
        cmsId: urlParams.get('cmsId'),
      };
      sessionStorage.setItem('CDAParams', JSON.stringify(shoppingCartParams));
      datadogRum.addAction('CDA IADD LOGIN PARAM', {
        type: 'CONSUMER',
        url: window.location.href,
        params: {
          shareCode: urlParams.get('shareCode'),
        },
      });
      // FIX FOR ENCODING
      const baseUrl = process?.env?.['NEXT_PUBLIC_CDA_AMD_LOGIN'] || '';
      const shareCodeParam = `shareCode=${shareCode || 'forced-redirect'}`;
      const redirectUriParam = `redirectUri=${window?.location.href?.split('?')?.[0]}`;
      const separator = baseUrl.includes('?') ? '&' : '?';
      const finalUrl = `${baseUrl}${separator}${shareCodeParam}&${redirectUriParam}`;
      if (checkWindow()) {
        if (isDev) {
          alert(`Redirect to: ${finalUrl}`);
        } else if (isMockCDA) {
          window.location.replace(
            `https://www.vodafone.it/accediavodafone/accedi.html?redirectURL=${
              window?.location.href?.split('?')?.[0]
            }`
          );
        } else {
          window.location.replace(finalUrl);
        }
      }
    }
  };

  useEffect(() => {
    if (isErrorSilentLogin) {
      const errorGeneric: ErrorDetail = {
        message: 'Si è verificato un errore.',
        title: 'Ops',
        actionEvent: () => {
          if (checkWindow()) {
            window.location.href = '/';
          }
        },
        actionText: 'Chiudi',
      };
      errorManager.handleError(ErrorService.getSeverityErrorHigh(), errorGeneric);
    } else if (isSuccessSilentLogin) {
      onSuccessSilentLogin();
    }
  }, [isErrorSilentLogin, isSuccessSilentLogin]);

  useEffect(() => {
    initCDA();
  }, []);

  return <Loading lottieOrSvg={cgradeloading?.login?.lottie} />;
};

export default VerificaIdentitaAmdocs;
